import React from 'react'
import Yup from './../../../helpers/custom-yup'
import styled from 'styled-components'
import StyledFlexContainer from './../../../components/containers/flex-container.component'
import { connect } from 'react-redux'
import { isMobile } from '../../../services/breakpoints.service'
import { breakpoints } from '../../../constants'
import { Formik } from 'formik'
import { toastActions } from '../../../actions/toast.actions'
import { getAddressViaCep } from '../../register/services/cep.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import {
	CEPInput,
	CPFInput,
	TextInput,
	EmailInput,
	PhoneInput,
	DateInput
} from '../../../components/form-components/inputs.component'
import { checkAge } from '../../../helpers/time-check.helper'

class BuyerDataComponent extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			isCepValid: false
		}

		this.lastSearchedZipCode = null

		this.searchByCep = searchByCep.bind(this)
		this.renderFormik = renderFormik.bind(this)
		this.onSearchCepError = onSearchCepError.bind(this)
		this.onSearchCepSuccess = onSearchCepSuccess.bind(this)
	}

	componentDidMount() {
		this.props.getFormRef(this.refs.form)
	}

	render() {
		return (
			<Formik
				ref="form"
				validationSchema={schema}
				render={this.renderFormik}
				initialValues={initialValues}
				onSubmit={this.props.onSubmit}
			/>
		)
	}
}

const schema = Yup.object().shape({
	rg: Yup.string()
		.required('Informe o RG')
		.nullable(),
	cpf: Yup.string()
		.cpf()
		.required('Informe o CPF'),
	name: Yup.string()
		.name()
		.required('Informe o nome'),
	phonenumber: Yup.string().required('Informe o telefone'),
	// zipcode: Yup.string()
	// 	.postalCode()
	// 	.required('Informe o CEP'),
	email: Yup.string()
		.email('O e-mail é inválido')
		.required('Informe o e-mail')
		.nullable(),
	emailconfirmation: Yup.string()
		.email('O e-mail é inválido')
		.equalTo(Yup.ref('email'), 'Os e-mails digitados não conferem')
		.required('Informe a confirmação do e-mail'),
	buyer_birthdate: Yup.string()
		.birthday()
		.required('Informe sua data de nascimento')
		.min('10', 'Favor digitar a data completa')
		.test('valid-age', 'Data de nascimento inválida', checkAge)
})

const initialValues = {
	name: '',
	rg: null,
	cpf: null,
	email: null,
	zipcode: null,
	phonenumber: null,
	buyer_birthdate: null
}

function renderFormik(props) {
	return (
		<StyledForm noValidate>
			<StyledFlexContainer marginTop={isMobile() ? 3.2 : 0.1}>
				<TextInput
					id="name"
					{...props}
					label="Nome"
					maxLength={32}
					className="col-4"
				/>
				<EmailInput
					{...props}
					id="email"
					label="E-mail"
					maxLength={256}
					className="col-4"
				/>
				<EmailInput
					{...props}
					id="emailconfirmation"
					label="Redigite o e-mail"
					maxLength={256}
					className="col-4"
				/>
			</StyledFlexContainer>
			<StyledFlexContainer marginTop={3.2}>
				<CPFInput
					id="cpf"
					{...props}
					label="CPF"
					className="col-3"
					onComplete={() => this.props.cpfChecked()}
					setFieldValueHandler={cpf => this.props.onChangeCpf(cpf)}
				/>
				<TextInput
					id="rg"
					label="RG"
					{...props}
					maxLength={32}
					className="col-3"
				/>
				{/* <CEPInput
					{...props}
					label="CEP"
					id="zipcode"
					className="col-3"
					onComplete={this.searchByCep}
				/> */}
				<DateInput
					{...props}
					id="buyer_birthdate"
					className="col-3"
					label="Data de nascimento"
				/>
				<PhoneInput
					{...props}
					maxLength={15}
					id="phonenumber"
					label="Telefone"
					className="col-3"
				/>
			</StyledFlexContainer>
		</StyledForm>
	)
}

const StyledForm = styled.form`
	margin-bottom: 2rem;
	transform: translateY(-3.2rem);
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		transform: unset;
	}
`

function searchByCep(cep) {
	const isSameCEP = cep === this.lastSearchedZipCode

	if (isSameCEP && this.state.isCepValid) {
		return
	} else if (isSameCEP && !this.state.isCepValid) {
		this.onSearchCepError()
		return
	}

	this.lastSearchedZipCode = cep

	const { hideLoading, showLoading } = this.props

	showLoading()
	getAddressViaCep(cep)
		.then(data => {
			hideLoading()
			if (data.erro) {
				this.onSearchCepError()
				this.setState({ isCepValid: false })
			} else {
				this.onSearchCepSuccess(data)
				this.setState({ isCepValid: true })
			}
		})
		.catch(() => {
			hideLoading()
			this.setState({ isCepValid: false })
			this.onSearchCepError()
		})
}

function onSearchCepError() {
	this.props.resetBuyerAddress()
	this.refs.form.setFieldValue('zipcode', '')
	this.props.toastError({ message: 'CEP inválido' })
}

function onSearchCepSuccess({ bairro, localidade, uf, logradouro, cep }) {
	this.props.setBuyerAddress({
		state: uf,
		zipCode: cep,
		city: localidade,
		street: logradouro,
		neighborhood: bairro
	})
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			setBuyerAddress: TicketSaleCreators.setBuyerAddress,
			resetBuyerAddress: TicketSaleCreators.resetBuyerAddress
		},
		dispatch
	)

const BuyerData = connect(null, mapDispatchToProps)(BuyerDataComponent)

export default BuyerData
